/* HOPER · apparitions au defilement pour la page d'accueil.
   11/09/2026. Meme geste que la page de presentation professionnelle : les blocs
   montent et s'allument quand ils entrent a l'ecran, et un fil de progression
   court en haut de la fenetre.

   Rien n'est deplace, rien n'est redimensionne : on ne touche qu'a l'opacite et
   a une translation de vingt-six pixels qui revient a zero. Le texte, les images
   et les espacements du theme sont intacts.

   Aucun IntersectionObserver : sur la page pro, un titre decoupe par clip-path
   n'etait jamais vu comme « entre a l'ecran ». On mesure la position reelle. */
(function () {
  'use strict';
  window.__hanim = true;

  var html = document.documentElement;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    html.classList.remove('hanim');
    return;
  }

  /* ---- quelles sections ---------------------------------------------- */
  // On laisse le diaporama d'ouverture tranquille : il est deja a l'ecran au
  // chargement, l'animer reviendrait a faire clignoter la page d'accueil.
  var HORS = /slideshow|announcement|header|footer|group-overlay/;
  var sections = [].filter.call(
    document.querySelectorAll('.shopify-section[class*="shopify-section--"]'),
    function (s) { return !HORS.test(s.className); });

  /* ---- quels blocs dans une section ---------------------------------- */
  function blocs(sec) {
    var hote = sec.querySelector('.section-stack, .v-stack, .prose');
    var base = hote ? [].slice.call(hote.children) : [];
    if (!base.length) {
      var c = sec.querySelector('.container');
      base = c ? [].slice.call(c.children) : [];
    }
    var out = [];
    base.forEach(function (el) {
      var enfants = [].slice.call(el.children);
      // une grille de cartes s'anime carte par carte, le reste d'un seul tenant
      var grille = enfants.length > 2 &&
        /grid|list|carousel|scroll/i.test((el.className || '') + ' ' + (enfants[0].className || ''));
      if (grille) out = out.concat(enfants.slice(0, 12));
      else out.push(el);
    });
    return out;
  }

  var aVoir = [];
  sections.forEach(function (sec) {
    blocs(sec).forEach(function (el, i) {
      if (!el || el.hasAttribute('data-hanim')) return;
      var r = el.getBoundingClientRect();
      if (r.height < 8) return;                 // un bloc vide n'a rien a reveler
      el.setAttribute('data-hanim', '');
      el.style.transitionDelay = (Math.min(i, 5) * 90) + 'ms';
      aVoir.push(el);
    });
  });

  var jauge = document.querySelector('.hanim-jauge span');
  var enAttente = false;

  function place() {
    enAttente = false;
    var h = window.innerHeight;
    for (var i = aVoir.length - 1; i >= 0; i--) {
      var b = aVoir[i].getBoundingClientRect();
      if (b.top < h * 0.9 && b.bottom > 0) {
        aVoir[i].setAttribute('data-hanim', 'vu');
        aVoir.splice(i, 1);
      }
    }
    if (jauge) {
      var total = document.documentElement.scrollHeight - h;
      var av = total > 0 ? (window.pageYOffset || document.documentElement.scrollTop) / total : 0;
      if (av < 0) av = 0; else if (av > 1) av = 1;
      jauge.style.transform = 'scaleX(' + av.toFixed(4) + ')';
    }
  }

  function auDefilement() {
    if (enAttente) return;
    enAttente = true;
    window.requestAnimationFrame(place);
  }

  window.addEventListener('scroll', auDefilement, { passive: true });
  window.addEventListener('resize', auDefilement);
  window.addEventListener('load', auDefilement);
  place();
})();
